<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="trafficModal" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">
              Create Ticket for Traffic
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="loading" class="loader"></div>
            <section v-else>
              <section>
                <div v-if="tickets.length>0" class="row">
                  <div  class="col-md-12">
                    <h5>Recently Created Tickets:</h5>
                    <ul>
                      <li v-for="(row, index) in tickets" :key="index">
                        {{formatDate(row.createdAt)}} <b>|</b> Subject: {{row.subject}}
                      </li>
                    </ul>
                    <hr>
                    <!--                    <span v-for="(row, index) in tickets" :key="index">-->
                    <!--                    {{formatDate(row.createdAt)}} <b>|</b> Subject: {{row.subject}} <br>-->
                    <!--                  </span>-->
                  </div>
                  <br>
                </div>
              </section>
              <section>
                <form @submit.prevent="submit">
                  <div class="row">
                    <div class="col-md-12">
                      <label>Subject:</label>
                      <input type="text" v-model="subject" name="subject" class="form-control" />
                    </div>
                  </div>
                  <section >
                    <div class="row mt-3" >
                      <div class="col-md-6">
                        <label>Message:</label>
                        <textarea class="form-control" rows="8" v-model="ticketMessage"></textarea>
                      </div>
                      <div class="col-md-6">
                        <label>Presets:</label>
                        <ul class="list-unstyled preset">
                          <li v-for="(macro, index) of presetMacros" :key="index" @click="useThisMacro(macro)">
                            <h6><span v-html="(macro.title)? macro.title : ''"></span></h6>
                            <span v-html="(macro.message) ? macro.message.split('\n')[0].substr(0,40).replace(/\n/g,'<br>') + '...' : macro.split('\n')[0].substr(0,40).replace(/\n/g,'<br>')"></span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <label>Select Status:</label>
                        <select class="form-control" v-model="ticketStatus">
                          <option value="Open">Open</option>
                          <option value="Closed">Closed</option>
                          <option value="Client-Reply">Client-Reply</option>
                          <option value="In-Progress">In-Progress</option>
                          <option value="Answered">Answered</option>
                          <option value="Requires Customer Update">Requires Customer Update</option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label>Select Priority:</label>
                        <select class="form-control" v-model="ticketPriority">
                          <option value="High">High</option>
                          <option value="Low">Low</option>
                          <option value="Medium">Medium</option>
                        </select>
                      </div>
                    </div>
                    <!--                    <div class="row">-->
                    <!--                      <div class="col-md-12" v-if="action !== 'Leave in migration'">-->
                    <!--                        <div class="custom-control custom-checkbox pull-left mt-3 ml-3 mr-sm-2">-->
                    <!--                          <input type="checkbox" v-model="sendTicketReply" name="action" class="custom-control-input" id="ticket-reply" />-->
                    <!--                          <label class="custom-control-label pt-1" for="ticket-reply">Send ticket reply</label>-->
                    <!--                        </div>-->
                    <!--                      </div>-->
                    <!--                    </div>-->
                  </section>
                  <!--                  <div class="row mt-3" >-->
                  <!--                    <div class="col-md-12">-->
                  <!--                      <span class="text-danger">Ticket ID is not associated with this migration.</span>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <div class="row">
                    <div class="col-md-12 ml-3 mt-3">
                      <input class="form-check-input" type="checkbox" v-model="assignTicketUrl" /> Assign Ticket URL?
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <button class="btn btn-sm btn-primary pull-right" type="submit" :disabled="loading">Submit</button>
                    </div>
                  </div>
                </form>
              </section>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import {db} from "@/firebase/init";
import swal from "sweetalert2";

export default {
  name: "trafficTicketModal",
  data(){
    return {
      ticketMessage: null,
      ticketStatus: 'Answered',
      ticketPriority: 'Low',
      subject: '',
      type: null,
      loading: false,
      sendTicketReply: false,
      index: null,
      action: 'Leave in migration',
      requiredTasks: [],
      presetMacros: [],
      trafficData: {},
      tickets: [],
      assignTicketUrl: false
    }
  },
  mounted() {
    // this.getMonitorTickets()
  },
  computed: {
    user () {
      return this.$store.getters.user;
    }
  },
  methods: {
    formatDate(date){
      return moment(date).local().fromNow()
    },
    async getTickets(){
      this.tickets = [];
      let ticketRef=await db.collection('trafficTickets').doc(this.trafficData.id.toString()).get()
      if(ticketRef.exists){
        const {tickets} = ticketRef.data()
        this.tickets= tickets
        console.log(this.tickets)
      }
    },
    async useThisMacro (macro) {
      console.log(macro)
      this.loading = true
      let msg = (macro.message) ? macro.message : macro;
      const userRef = await db.collection('users').doc(this.trafficData.uid).get()
      const user = userRef.data()
      msg = msg.replace(/{firstName}/g, user.firstName)
      msg = msg.replace(/{lastName}/g, user.lastName)
      msg = msg.replace(/{domain}/g, this.trafficData.primaryDomain)
      msg = msg.replace(/{signature}/g, this.user.signature)
      this.ticketMessage = msg;
      this.ticketStatus = (macro.status) ? macro.status : 'Answered';
      this.ticketPriority = (macro.priority) ? macro.priority : 'Low';
      this.subject= macro.title
      this.loading = false
    },
    async load (presets, trafficData) {
      this.presetMacros=presets
      this.trafficData=trafficData
      await this.getTickets()
      console.log(trafficData)
      $('#trafficModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");

    },
    async submit () {
      try {
        this.loading = true
        let accountRef = await db.collection('users').doc(this.trafficData.uid).get();
        accountRef = accountRef.data();
        let response=await this.$http.post('host-bill/open-new-ticket', {
          grant_type: 'token',
          message: this.ticketMessage,
          priority: this.ticketPriority,
          clientID: accountRef.customerID,
          subject: this.subject,
          status: this.ticketStatus,
          name: this.user.firstName + ' ' + this.user.lastName
        })
        console.log('response', response)
        this.tickets.push({
          subject: this.subject,
          message: this.ticketMessage,
          priority: this.ticketPriority,
          ticketId: response.data.ticket_id,
          status: this.ticketStatus,
          trafficId: this.trafficData.id,
          addedBy: this.user.firstName + ' ' + this.user.lastName,
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        })
        await db.collection('trafficTickets').doc(this.trafficData.id.toString()).set({tickets: this.tickets})
        if(this.assignTicketUrl){
          await db.collection('trafficBillings').doc(this.trafficData.id.toString())
              .update({ticket: ` https://www.bigscoots.com/portal/admin/?cmd=tickets&action=view&brc=MTA&list=requirescustomerupdate&num=${response.data.ticket_id}`})
        }
        swal({
          title: "Success",
          text: 'Ticket has been created successfully',
          type: "success"
        })
        $('#trafficTicketModal').modal('hide');

      } catch (e) {
        this.loading = false
        swal({
          title: "Error",
          text: e.toString(),
          type: "error"
        })
      }finally
      {
        this.loading = false
        this.ticketMessage=''
        this.subject=''
        $('#trafficTicketModal').modal('hide');

      }
    },
  }
}
</script>

<style lang="scss" scoped>
.preset {
  height: 230px;
  overflow: auto;
  li {
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.3);
    padding: 2px;
    background-color: rgba(0,0,0,0.1);
    border-radius: 3px;
    margin: 2px 0;
  }
}
</style>
